export default "__VITE_ASSET__DGSagBoF__"